import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Initialize from localStorage, defaulting to Arabic
  const [isArabic, setIsArabic] = useState(() => {
    const saved = localStorage.getItem('mear_language');
    return saved ? saved === 'ar' : true;
  });

  // Set initial document properties on mount
  useEffect(() => {
    document.dir = isArabic ? 'rtl' : 'ltr';
    document.documentElement.lang = isArabic ? 'ar' : 'en';
  }, [isArabic]);

  const toggleLanguage = () => {
    const newLang = !isArabic;
    setIsArabic(newLang);
    // Persist to localStorage
    localStorage.setItem('mear_language', newLang ? 'ar' : 'en');
    // Update document direction for RTL support
    document.dir = newLang ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang ? 'ar' : 'en';
  };

  const t = (englishText, arabicText) => {
    return isArabic ? arabicText : englishText;
  };

  const value = {
    isArabic,
    toggleLanguage,
    t, // translation function
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext; 